
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('text',{attrs:{"font-family":"HelveticaNeue-Bold, Helvetica Neue","font-size":"10","font-weight":"bold","letter-spacing":".125"}},[_c('tspan',{attrs:{"x":"7","y":"19"}},[_v('15')])]),_c('path',{attrs:{"d":"M13.933 4H5a5 5 0 00-5 5v3a5 5 0 005 5h1.166v-2H5a3 3 0 01-3-3V9a3 3 0 013-3h8.933v4L19 5l-5.067-5v4z"}})])
          )
        }
      }
    